<section class="payment-modern">
  <h2>Métodos de Pago</h2>
    <p>Los estudiantes pagan únicamente el 50% del costo de los cursos. <br>Aceptamos diferentes vías de pago en los siguientes bancos:</p>
  <div class="payment-grid">
    <div class="payment-option">
      <img class="img-sinpe" src="assets/images/logos/sinpe_logo.png" alt="Sinpe Móvil" />
      <span>Sinpe Móvil</span>
    </div>
    <div class="payment-option">
      <img class="img-bac" src="assets/images/logos/bac_logo.svg" alt="BAC Credomatic" />
      <span>BAC Credomatic</span>
    </div>
    <div class="payment-option">
      <img class="img-bcr" src="assets/images/logos/bcr_logo.svg" alt="Banco BCR" />
      <span>Banco BCR</span>
    </div>
    <div class="payment-option">
      <img class="img-nacional" src="assets/images/logos/nacional_logo.png" alt="Banco Nacional" />
      <span>Banco Nacional</span>
    </div>
  </div>
</section>
